import styled from "styled-components"
import bgImage from "assets/images/background.jpg"

export const Container = styled.div`
  /* min-height: 100vh; */
  background-color: #f8f8f8;
  /* background-image: url(${bgImage}); */
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  color: white;
`
